import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  CircularProgress,
  Alert
} from '@mui/material';
import {
  Close as CloseIcon,
  Refresh as RefreshIcon
} from '@mui/icons-material';
import SliderCaptcha from './SliderCaptcha';

const CaptchaModal = ({ 
  open, 
  onClose, 
  onVerify, 
  onReset,
  title = "安全验证",
  width = 300,
  height = 125
}) => {
  const [isVerified, setIsVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // 当弹窗打开时重置状态
  useEffect(() => {
    if (open) {
      setIsVerified(false);
      setIsLoading(false);
      setError('');
    }
  }, [open]);

  const handleCaptchaVerify = (verificationToken) => {
    setIsVerified(true);
    setIsLoading(false);
    setError('');
    onVerify && onVerify(verificationToken);
  };

  const handleCaptchaReset = () => {
    setIsVerified(false);
    setIsLoading(false);
    setError('');
    onReset && onReset();
  };

  const handleClose = () => {
    if (isVerified) {
      onClose && onClose();
    }
  };

  const handleVerifyClick = () => {
    if (isVerified) {
      onClose && onClose();
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          minHeight: 400
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        pb: 1
      }}>
        <Typography variant="h6" component="div">
          {title}
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ color: 'text.secondary' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            请完成下方验证以继续操作
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center',
            mb: 2
          }}>
            <SliderCaptcha
              onVerify={handleCaptchaVerify}
              onReset={handleCaptchaReset}
              width={width}
              height={height}
            />
          </Box>

          <Typography variant="caption" color="text.secondary">
            拖动滑块完成拼图验证
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2, pt: 1 }}>
        <Button
          onClick={onClose}
          color="inherit"
        >
          取消
        </Button>
        <Button
          onClick={handleVerifyClick}
          variant="contained"
          disabled={!isVerified}
          startIcon={isLoading ? <CircularProgress size={16} /> : null}
        >
          {isVerified ? '验证完成' : '请先完成验证'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CaptchaModal;
